/* Sizing guide (roadmap JJ, 2026-10-13): the finish and shape pickers that drive the size drawing (assets/jh-size-nest.js),
   the facts that follow the finish, and the "Which size for your wall" drawings. The page works without it: the
   drawing, the tables and the tips are in the markup. State goes in the address bar (?finish=framed&size=2&shape=landscape),
   so a size and finish can be linked to. Every number and word is written with setAttribute or textContent; nothing is
   built from strings of markup. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sizing-guide]');
  var fig = root && root.querySelector('[data-jh-sizes]');
  if (!fig) return;
  if (!window.JhNest) return;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var landscapeOn = root.dataset.landscapeOn === 'true';
  var finishRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="finish"]'));
  var shapeRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="shape"], input[name="shape2"]'));
  var facts = Array.prototype.slice.call(root.querySelectorAll('[data-facts]'));
  var guide = root.querySelector('[data-guide]');
  var keys = finishRadios.map(function (r) { return r.value; });
  var labels = {};
  finishRadios.forEach(function (r) { labels[r.value] = r.dataset.label; });

  var q = new URLSearchParams(location.search);
  var size = Number(q.get('size'));
  var chipCount = fig.querySelectorAll('.jh-fm__chip').length;
  var start = {
    size: Number.isInteger(size) && size >= 0 && size < chipCount ? size : null,
    finish: keys.indexOf(q.get('finish')) >= 0 ? q.get('finish') : keys[0],
    orient: landscapeOn && q.get('shape') === 'landscape' ? 'landscape' : 'portrait'
  };
  var state = { finish: start.finish, label: labels[start.finish], orient: start.orient };
  if (start.size !== null) state.size = start.size;
  if (start.orient === 'landscape' && finishRadios.some(function (r) { return r.value === start.finish && r.hasAttribute('data-no-landscape'); })) { state.finish = keys[0]; state.label = labels[keys[0]]; }

  var nest = window.JhNest(fig, {
    state: state,
    controls: root.querySelector('[data-wall]'),
    labels: labels,
    depthKinds: ['framed', 'hanger', 'acrylic', 'canvas'],
    noOverallKinds: ['framed'],
    onChange: function (s) {
      var u = new URL(location.href);
      u.searchParams.set('size', s.size);
      u.searchParams.set('finish', s.finish);
      if (s.orient === 'landscape') u.searchParams.set('shape', 'landscape'); else u.searchParams.delete('shape');
      try { history.replaceState(null, '', u); } catch (e) { /* a sandboxed preview may refuse; the page still works */ }
    }
  });
  if (!nest) return;

  function showFacts(k) { facts.forEach(function (d) { d.hidden = d.dataset.facts !== k; }); }
  function setFinish(k) {
    var r = finishRadios.find(function (x) { return x.value === k; });
    if (r && !r.checked) r.checked = true;
    nest.set({ finish: k, label: labels[k] });
    showFacts(k);
  }
  finishRadios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setFinish(r.value); }); });

  // Shape (from the Naksha launch only). Landscape prints have no hanger and no acrylic: those buttons grey out and say so.
  function setShape(o) {
    shapeRadios.forEach(function (r) { r.checked = r.value === o; });
    finishRadios.forEach(function (r) {
      if (!r.hasAttribute('data-no-landscape')) return;
      var note = r.nextElementSibling && r.nextElementSibling.querySelector('.sg-opt__on');
      r.disabled = o === 'landscape';
      if (note) note.textContent = o === 'landscape' ? 'Not on Naksha maps' : r.dataset.short;
    });
    var cur = finishRadios.find(function (r) { return r.checked; });
    if (o === 'landscape' && cur && cur.disabled) setFinish(keys[0]);
    nest.set({ orient: o });
    drawGuide(o);
  }
  shapeRadios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setShape(r.value); }); });

  // The size figures at the top pick that size, then the link jumps to the drawing
  root.querySelectorAll('[data-pick-size]').forEach(function (a) { a.addEventListener('click', function () { nest.set({ size: Number(a.dataset.pickSize) }, true); }); });

  // Which size for your wall. Each tile is drawn at one scale (1 unit = 1 cm), so the sizes compare honestly.
  // The furniture ranges come from the two-thirds rule and the nearest size (portrait widths 30, 50, 70; landscape 40, 70, 100):
  // the print is about two thirds of the furniture, and the ranges meet halfway between neighbouring sizes.
  var ADVICE = {
    portrait: [
      { range: 'under 60 cm', eg: 'a bedside table', fur: 50 },
      { range: '60 to 90 cm', eg: 'a chest of drawers', fur: 80 },
      { range: '90 to 130 cm', eg: 'a desk', fur: 115 },
      { range: 'over 130 cm', eg: 'a sofa or a bed', fur: 175 }
    ],
    landscape: [
      { range: 'under 80 cm', eg: 'a bedside table', fur: 60 },
      { range: '80 to 130 cm', eg: 'a desk', fur: 105 },
      { range: '130 to 185 cm', eg: 'a sideboard', fur: 150 },
      { range: 'over 185 cm', eg: 'a long sofa', fur: 215 }
    ]
  };
  var chips = Array.prototype.slice.call(fig.querySelectorAll('.jh-fm__chip'));
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }
  function sv(tag, attrs, parent) { var e = document.createElementNS(SVGNS, tag); Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); }); if (parent) parent.appendChild(e); return e; }
  function tileSvg(t) {
    var VW = 230, VH = 190, FL = 185, top = 135, legs = 7, cx = VW / 2, gap = 6;
    var s = sv('svg', { viewBox: '0 0 ' + VW + ' ' + VH, 'aria-hidden': 'true', focusable: 'false' });
    sv('line', { class: 'sg-tile__floor', x1: 0, y1: FL, x2: VW, y2: FL }, s);
    var fx = cx - t.fur / 2;
    sv('rect', { class: 'sg-tile__fur', x: fx, y: top, width: t.fur, height: FL - top - legs, rx: 2 }, s);
    sv('line', { class: 'sg-tile__fur', x1: fx + 5, y1: FL - legs, x2: fx + 5, y2: FL }, s);
    sv('line', { class: 'sg-tile__fur', x1: fx + t.fur - 5, y1: FL - legs, x2: fx + t.fur - 5, y2: FL }, s);
    var total = t.art.reduce(function (a, r) { return a + r[0]; }, 0) + gap * (t.art.length - 1);
    var x = cx - total / 2, bottom = top - 18;
    t.art.forEach(function (r) { sv('rect', { class: 'sg-tile__art', x: x, y: bottom - r[1], width: r[0], height: r[1] }, s); x += r[0] + gap; });
    return s;
  }
  function drawGuide(o) {
    if (!guide) return;
    var advice = ADVICE[o];
    var dims = chips.map(function (c) { var w = Number(c.dataset.w), h = Number(c.dataset.h); return o === 'landscape' ? [Math.max(w, h), Math.min(w, h)] : [Math.min(w, h), Math.max(w, h)]; });
    var tiles = chips.map(function (c, i) { return { size: c.dataset.name, dims: dims[i][0] + ' × ' + dims[i][1] + ' cm', art: [dims[i]], a: advice[i] }; });
    var mid = dims[Math.min(1, dims.length - 1)];
    tiles.push({ size: guide.dataset.pair || 'A pair', dims: 'Medium or Large, side by side', art: [mid, mid], a: advice[3] });
    while (guide.firstChild) guide.removeChild(guide.firstChild);
    var line = guide.dataset.furniture || 'Furniture {range} wide, like {example}.';
    tiles.forEach(function (t) {
      var li = el('li', 'sg-tile');
      li.appendChild(tileSvg({ fur: t.a.fur, art: t.art }));
      li.appendChild(el('p', 'sg-tile__size', t.size));
      li.appendChild(el('p', 'sg-tile__dims', t.dims));
      var p = el('p', 'sg-tile__for');
      var parts = line.split(/(\{range\}|\{example\})/);
      parts.forEach(function (part) {
        if (part === '{range}') p.appendChild(el('b', '', t.a.range));
        else if (part === '{example}') p.appendChild(document.createTextNode(t.a.eg));
        else if (part) p.appendChild(document.createTextNode(part));
      });
      li.appendChild(p);
      guide.appendChild(li);
    });
  }

  var shapeNow = nest.get().orient;
  showFacts(nest.get().finish);
  var cur = finishRadios.find(function (r) { return r.value === nest.get().finish; });
  if (cur) cur.checked = true;
  if (landscapeOn) setShape(shapeNow); else drawGuide('portrait');
})();
